
      import { createComponent } from '@lit/react'
      import { type EventName } from '@lit/react'
      import * as React from 'react'

      import Component from '../../components/overlay/overlay.component.js'
      import type { DdsBeforeOpenEvent } from '../../events/events'
import type { DdsOpenedEvent } from '../../events/events'
import type { DdsBeforeCloseEvent } from '../../events/events'
import type { DdsClosedEvent } from '../../events/events'
      export type { DdsBeforeOpenEvent } from '../../events/events'
export type { DdsOpenedEvent } from '../../events/events'
export type { DdsBeforeCloseEvent } from '../../events/events'
export type { DdsClosedEvent } from '../../events/events'

      const tagName = 'dap-ds-overlay'

      /**
 * `dap-ds-overlay`
 * @summary An overlay is a container for overlay content.
 * @element dap-ds-overlay
 * @title - Overlay
 *
 * @property {boolean} open - The open state of the overlay.
 *
 * @event {CustomEvent} dds-before-open - Fires before the overlay opens.
 * @event {CustomEvent} dds-opened - Fires after the overlay opens.
 * @event {CustomEvent} dds-before-close - Fires before the overlay closes.
 * @event {CustomEvent} dds-closed - Fires after the overlay closes.
 *
 * @slot - The content of the overlay.
 *
 * @csspart base - The overlay element
 *
 * @cssproperty --dds-overlay-z-index - Controls the z-index of the overlay (default: 1)
 * @cssproperty --dds-overlay-background - Controls the background of the overlay (default: var(--dds-black-10))
 * @cssproperty --dds-overlay-opacity-closed - Controls the opacity when overlay is closed (default: 0)
 * @cssproperty --dds-overlay-opacity-open - Controls the opacity when overlay is open (default: 1)
 * @cssproperty --dds-overlay-transition-duration - Controls the transition duration (default: var(--dds-transition-fast))
 * @cssproperty --dds-overlay-transition-timing - Controls the transition timing function (default: var(--dds-easing-ease-in-out))
 */
      const reactWrapper = createComponent({
        tagName,
        elementClass: Component,
        react: React,
        events: {
          onDdsBeforeOpen: 'dds-before-open' as EventName<DdsBeforeOpenEvent>,
onDdsOpened: 'dds-opened' as EventName<DdsOpenedEvent>,
onDdsBeforeClose: 'dds-before-close' as EventName<DdsBeforeCloseEvent>,
onDdsClosed: 'dds-closed' as EventName<DdsClosedEvent>
        },
        displayName: "DapDSOverlay"
      })

      export default reactWrapper
    